class Option {
    answer: string;
    isTrue: boolean;

    constructor(answer: string, isTrue: boolean) {
        this.answer = answer;
        this.isTrue = isTrue;
    }
}

class Question {
    question: string;
    options: Option[];

    constructor(question: string, options: Option[]) {
        this.question = question;
        this.options = options;
    }
}

interface QuizData {
    maxNumOfQuestionsPerRound: number;
    questions: Question[];
}

interface CurrAnswer {
    ctx: React.ChangeEvent<HTMLInputElement>,
    optionIndex: number
}

interface Answer {
    questionIndex: number;
    optionIndex: number;
}

interface Quiz {
    questions: Question[];
    answers: Answer[];
    currentQuestionIndex: number;
    score: number;
    isCompleted: boolean;
}

export { Option, Question };
export type { Quiz, Answer, CurrAnswer };
